import { Body } from '@e2n/ui/v2';
import { Location } from '@/domain/mitarbeiter/features/rotationsplan/components/Location';
import { KalenderArbeitsbereich as ArbeitsbereichType } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByArbeitsbereiche/KalenderArbeitsbereich';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function Arbeitsbereich({
  arbeitsbereich,
}: {
  arbeitsbereich: ArbeitsbereichType;
}) {
  return (
    <div className="sticky left-0 z-10 flex flex-col justify-center gap-0.5 border-r border-solid border-separators-non-opaque bg-white min-h-14 px-1">
      <div className="flex items-center gap-2 min-w-0">
        <FontAwesomeIcon
          icon={faCircle}
          color={arbeitsbereich.getBorderColor()}
          className="size-2.5 shrink-0"
        />
        <Body className="truncate">{arbeitsbereich.name}</Body>
      </div>
      <Location
        className="text-labels-secondary"
        standort={arbeitsbereich.standort}
      />
    </div>
  );
}
